import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import PerchLoading from './components/PerchLoading';
import useRequireSudo from './hooks/useRequireSudo';

// Module scope so the chunk is fetched at most once, and only once a sudoer renders the gate.
const PerchApp = React.lazy(() => import('@feathr/extender/App/Perch'));

/**
 * Resolves sudo before constructing the lazy Perch app, so non-sudoers never download the Perch chunk.
 * `PerchApp` still runs `useRequireSudo` itself as defense in depth.
 */
function PerchGate(): JSX.Element {
  const { isAuthorized, isPending } = useRequireSudo();

  if (isPending) {
    return <PerchLoading />;
  }

  if (!isAuthorized) {
    // Redirect to `/` is already triggered by `useRequireSudo`.
    return <></>;
  }

  return (
    <React.Suspense fallback={<PerchLoading />}>
      <PerchApp />
    </React.Suspense>
  );
}

export default observer(PerchGate);
